// Student PaymentsPage — own payment history.
import { useFetch } from "../../hooks/useApi.js";
import Badge from "../../components/shared/Badge.js";
import type { Payment } from "@dm-lms/shared/types";

const STATUS_TONE: Record<Payment["status"], "green" | "gold" | "red" | "gray"> = {
  success:  "green",
  pending:  "gold",
  failed:   "red",
  refunded: "gray",
};

export default function PaymentsPage() {
  const { data, isLoading, error } = useFetch<Payment[]>("/api/payments/history");

  return (
    <div className="dm-page">
      <h1 className="text-2xl font-semibold text-dm-navy mb-6">Payments</h1>

      {isLoading && <p className="text-dm-slate text-sm">Loading payments…</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {!isLoading && !error && (
        (data ?? []).length === 0 ? (
          <p className="text-dm-slate text-sm">No payments yet.</p>
        ) : (
          <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 text-left text-dm-slate">
                <tr>
                  <th className="px-4 py-3 font-medium">Code</th>
                  <th className="px-4 py-3 font-medium">Amount (KES)</th>
                  <th className="px-4 py-3 font-medium">Method</th>
                  <th className="px-4 py-3 font-medium">Status</th>
                  <th className="px-4 py-3 font-medium">Paid</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {(data ?? []).map((payment) => (
                  <tr key={payment.id}>
                    <td className="px-4 py-3 text-dm-navy font-medium">{payment.code}</td>
                    <td className="px-4 py-3">{payment.amountKes.toLocaleString()}</td>
                    <td className="px-4 py-3 uppercase">{payment.method}</td>
                    <td className="px-4 py-3"><Badge tone={STATUS_TONE[payment.status]}>{payment.status}</Badge></td>
                    <td className="px-4 py-3">{payment.paidAt ? new Date(payment.paidAt).toLocaleDateString() : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}
